
import React from 'react'

import Image from 'next/image'

function Productimage({ item }) {
    return (
        (item && item.media && item.media[0] && item.media[0].original_url) ? (
            <Image
                src={item.media[0].original_url}
                alt={item.name}
                width="200"
                height="200"
                className="w-full rounded"
                placeholder="blur"

                blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII="
            />

        ) : (
            <Image
                src={process.env.NEXT_PUBLIC_COMING_SOON_IMAGE}
                alt={item.name}
                width="200"
                height="200"
                className="w-full rounded"
                placeholder="blur"

                blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII="
            />
        )
    );
}

export default Productimage;